import { useOfficeComponentContext } from '@office-start/component-context-service';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { useEffect } from 'react';
var useInitializeFabricIconSubsetUtility = function (skipExecution, delayExecution) {
    var _a;
    var componentContext = (_a = useOfficeComponentContext()) === null || _a === void 0 ? void 0 : _a.data;
    useEffect(function () {
        if (!componentContext || skipExecution) {
            return;
        }
        var cdnDomain = componentContext.inMockMode
            ? undefined
            : componentContext.cdnDomain;
        if (delayExecution) {
            scheduleWork(function () {
                return import(
                /* webpackChunkName: "os-fisu" */ '@office-start/fabric-icon-subset-utility').then(function (mod) {
                    return mod.initializeIcons(false /* do not use local files */, true /* use fluent font */, cdnDomain);
                });
            }, IDLE_VERYLOW_PRIORITY, 'initializeIcons');
        }
        else {
            import(
            /* webpackChunkName: "os-fisu" */ '@office-start/fabric-icon-subset-utility').then(function (mod) {
                return mod.initializeIcons(false /* do not use local files */, true /* use fluent font */, cdnDomain);
            });
        }
    }, [componentContext, delayExecution, skipExecution]);
};
export var useInitializeIcons = function (skipExecution, delayExecution) {
    useEffect(function () {
        if (!skipExecution) {
            if (delayExecution) {
                scheduleWork(function () {
                    // v8 file type icons
                    import(
                    /* webpackChunkName: "fui-rfti" */ '@fluentui/react-file-type-icons').then(function (mod) { return mod.initializeFileTypeIcons(); });
                    // v7 file type icons
                    import(
                    /* webpackChunkName: "uif-fti" */ '@uifabric/file-type-icons').then(function (mod) { return mod.initializeFileTypeIcons(); });
                }, IDLE_VERYLOW_PRIORITY, 'initializeFileTypeIcons');
            }
            else {
                import(
                /* webpackChunkName: "fui-rfti" */ '@fluentui/react-file-type-icons').then(function (mod) { return mod.initializeFileTypeIcons(); });
                import(
                /* webpackChunkName: "uif-fti" */ '@uifabric/file-type-icons').then(function (mod) { return mod.initializeFileTypeIcons(); });
            }
        }
    }, [delayExecution, skipExecution]);
    // v7 initialize icons
    useInitializeFabricIconSubsetUtility(skipExecution, delayExecution);
};
//# sourceMappingURL=useInitializeIcons.js.map